<template>
  <ZigzagServiceLayout
    mainTitle="Telemedicina: Cuidados Acessíveis Onde Quer Que Você Esteja"
    mainDescription="Experimente cuidados médicos de alta qualidade no conforto da sua casa. Nossa plataforma de telessaúde conecta você com profissionais para consultas, acompanhamentos e tratamentos especializados."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'TelemedicineContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'TELESSAÚDE',
          title: 'Atenção Primária Geral',
          subtitle: 'Cuidados médicos acessíveis no conforto da sua casa.',
          paragraphs: [
            "Nossos serviços de atenção primária em telessaúde oferecem a você acesso direto a profissionais de saúde experientes para uma ampla variedade de necessidades médicas não emergenciais. Seja lidando com uma doença comum ou precisando de uma renovação de receita, nossa clínica virtual oferece uma solução conveniente.",
            "Por meio de videoconsultas seguras, podemos avaliar seus sintomas, fornecer diagnósticos precisos e desenvolver planos de tratamento personalizados, tudo sem a necessidade de ir a um consultório físico."
          ],
          list: [
            "Consultas para doenças comuns, como resfriados, gripes e infecções",
            "Acompanhamento de exames de rotina e orientações preventivas",
            "Manejo de condições crônicas estáveis",
            "Renovação de receitas e gerenciamento de medicamentos"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        },
        {
          label: 'SAÚDE METABÓLICA',
          title: 'Gerenciamento de Peso',
          subtitle: 'Abordagem abrangente baseada em evidências para atingir um peso saudável.',
          paragraphs: [
            "Programas integrados de gerenciamento de peso e saúde metabólica fornecem uma abordagem abrangente para alcançar um peso saudável e melhorar a função metabólica geral. Esses programas diferem das dietas tradicionais ao incorporar supervisão médica e tecnologia avançada para monitoramento.",
            "Um pilar dos programas modernos é o uso de telessaúde e ferramentas digitais para aumentar o acesso e o acompanhamento. O monitoramento virtual aproveita a tecnologia para rastrear o progresso do paciente e fornecer suporte contínuo fora das consultas regulares."
          ],
          list: [
            "<strong>Supervisão Médica:</strong> Avaliação abrangente, incluindo histórico e metas.",
            "<strong>Monitoramento Virtual:</strong> Rastreamento remoto do progresso e suporte contínuo.",
            "<strong>Aconselhamento Nutricional:</strong> Planejamento alimentar, coaching comportamental e educação.",
            "<strong>Terapias Supervisionadas:</strong> Medicamentos seguros e aprovados para perda de peso."
          ],
          image: '/images/services/weight-management-telehealth.png'
        },
        {
          label: 'CUIDADOS ESPECIALIZADOS',
          title: "Saúde do Homem e da Mulher",
          subtitle: 'Otimização hormonal personalizada e estratégias de bem-estar.',
          paragraphs: [
            "Os desequilíbrios hormonais podem impactar significativamente a sua qualidade de vida, afetando níveis de energia, humor, metabolismo e saúde sexual. Nossa plataforma de telessaúde oferece um ambiente discreto para discutir essas questões delicadas.",
            "Oferecemos avaliações completas, incluindo a análise do histórico médico e a coordenação dos exames laboratoriais necessários para avaliar com precisão os seus níveis hormonais e desenvolver um plano de tratamento personalizado."
          ],
          list: [
            "Consultas de terapia de reposição de testosterona (TRT) para homens",
            "Terapia de reposição hormonal (TRH) e suporte à menopausa para mulheres",
            "Tratamento de sintomas como fadiga, ganho de peso e baixa libido",
            "Monitoramento contínuo e ajustes de dosagem por meio de visitas virtuais"
          ],
          image: '/images/services/hormone-therapy-telehealth.png'
        },
        {
          label: 'BEM-ESTAR E APOIO',
          title: 'Saúde Mental e Estilo de Vida',
          subtitle: 'Atendimento compassivo para o seu bem-estar emocional.',
          paragraphs: [
            "A saúde mental é um componente vital da sua saúde geral, e nossos serviços de telessaúde facilitam mais do que nunca priorizar o seu bem-estar emocional. Desde o gerenciamento de estresses diários até o tratamento de desafios mais complexos, nossa equipe compassiva está aqui para apoiar você.",
            "Proporcionamos um espaço virtual seguro e sem julgamentos para discutir suas preocupações, aprender estratégias eficazes de enfrentamento e trabalhar em prol de uma vida mais equilibrada e plena."
          ],
          list: [
            "Aconselhamento para gerenciamento de estresse, ansiedade e depressão",
            "Coaching comportamental para apoiar mudanças no estilo de vida",
            "Estratégias para melhorar a qualidade do sono e construir resiliência",
            "Integração com nossos programas de gerenciamento de peso e nutrição"
          ],
          image: '/images/services/mental-health-telehealth.png'
        }
      ]
    };
  }
};
</script>
